import React, { useContext, useEffect, useState } from "react";
import { FilterList,  Close,  Add,  DeleteForever,  LocationOn,} from "@mui/icons-material";
import { Badge,  Button,  Popover,  Typography,  Box,  Grid,  FormControl,  InputLabel,  Select,  MenuItem,  TextField,  IconButton,  RadioGroup,  FormControlLabel,  Radio,  FormLabel,  Alert,  Divider,  Chip,  Autocomplete,  Slider,} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FormProvider,  useForm,  Controller,  useFieldArray,  get,} from "react-hook-form";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { NotificationServices } from "./NotificationServices";
import { CrudServices } from "../../MasterService/CrudServices";

const AllAppliedFIlters = ({
  externalClear = false,
  defaultFilterCount = 1,
  defaultFilterOptions,
  enableLocationFilters = false,
  enableGeoFilters = true,
  defaultLocationFilters = {
    locationFilter: "radius",
    centerCoordinates: { lat: "", lng: "" },
    radius: "",
    polygon: [],
    selectedPolygons: [],
  },
  audienceType,
  notificationData,
}) => {
  // const {notificationData} = useContext(NotificationDataContext);
  const filterFormMethod = useForm({
    mode: "onChange",
    defaultValues: {
      filterOption:
        defaultFilterOptions?.length > 0
          ? defaultFilterOptions
          : Array(defaultFilterCount)
              .fill()
              .map(() => ({
                fieldName: "",
                operator: "contains",
                value: null,
              })),
      locationFilters: defaultLocationFilters,
    },
  });

  const { control, handleSubmit, reset, setValue, getValues, watch } =
    filterFormMethod;
  const [anchorEl, setAnchorEl] = useState(null);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "filterOption",
  });

  useEffect(() => {
    if (externalClear) {
      reset({
        filterOption: [
          {
            fieldName: "",
            operator: "contains",
            value: null,
          },
        ],
        locationFilters: defaultLocationFilters,
      });
    }
  }, [externalClear, reset, defaultLocationFilters]);

  const filterOption = watch("filterOption");
  const locationFilters = watch("locationFilters");

  const activeBasicFilters = filterOption.filter((option) => {
    const hasFieldName = option.fieldName && option.fieldName.trim() !== "";
    const hasOperator = option.operator && option.operator.trim() !== "";

    let hasValidValue = false;
    if (option.value !== null && option.value !== undefined) {
      if (typeof option.value === "string") {
        hasValidValue = option.value.trim() !== "";
      } else if (Array.isArray(option.value)) {
        hasValidValue = option.value.length > 0;
      } else {
        hasValidValue = true;
      }
    }

    return hasFieldName && hasOperator && hasValidValue;
  }).length;

  const activeLocationFilters =
    enableLocationFilters &&
    ((locationFilters.locationFilter === "radius" &&
      locationFilters.centerCoordinates.lat &&
      locationFilters.centerCoordinates.lng &&
      locationFilters.radius) ||
      (locationFilters.locationFilter === "polygon" &&
        locationFilters.selectedPolygons &&
        locationFilters.selectedPolygons.length > 0))
      ? 1
      : 0;

  const activeBadgeContent = activeBasicFilters + activeLocationFilters;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const openFilterForm = Boolean(anchorEl);
  const [cityList, setCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const fetchStateCityLists = async () => {
    let cities = [];
    let states = [];
    if (notificationData.audienceType === "customer") {
      const customerAddresses =
        await NotificationServices.fetchCustomersAddress();
      if (customerAddresses.success == "1") {
        cities = customerAddresses.data.cities;
        states = customerAddresses.data.states;
      }
    } else if (notificationData.audienceType === "expert") {
      const expertAddresses = await NotificationServices.fetchExpertsAddress();
      if (expertAddresses.success == "1") {
        cities = expertAddresses.data.cities;
        states = expertAddresses.data.states;
      }
    }
    setCityList(cities);
    setStateList(states);
  };
  useEffect(() => {
    if (notificationData) {
        if(notificationData.filters){
            reset({
                filterOption:
                    notificationData?.filters.filterOptions?.length > 0
                    ? notificationData?.filters.filterOptions
                    : Array(defaultFilterCount)
                        .fill()
                        .map(() => ({
                            fieldName: "",
                            operator: "contains",
                            value: null,
                        })),
                locationFilters: notificationData?.filters?.locationFilters,
            })
        }
        if(notificationData.audienceType){
            fetchStateCityLists();
        }
    }
  }, [notificationData]);
  const [categoryList, setCategoryList] = useState([]);
  useEffect(() => {
    const fetchCategoryList = async () => {
      try {
        const categoryListResponse = await CrudServices.categoryList();
        console.log("category list Response:", categoryListResponse);
        if (categoryListResponse.success === 1) {
          setCategoryList(categoryListResponse.data);
        }
      } catch (error) {}
    };
    fetchCategoryList();
  }, []);
  const getFilterableColumns = () => {
    if (notificationData.audienceType === "customer") {
      return [
        {
          key: "mobileNumber",
          label: "Mobile Number",
          type: "number",
        },

        // Gender - Multi Select
        {
          key: "gender",
          label: "Gender",
          type: "multiselect",
          options: [
            { value: "Male", label: "Male" },
            { value: "Female", label: "Female" },
            { value: "Prefer Not To Say", label: "Prefer Not To Say" },
          ],
        },

        // Activity Based Filters
        {
          key: "lastActive",
          label: "Last Active",
          type: "select",
          options: [
            { value: "7", label: "Within 7 Days" },
            { value: "30", label: "Within 30 Days" },
            { value: "90", label: "Within 90 Days" },
          ],
        },
        {
          key: "lastInactive",
          label: "Inactive For Days",
          type: "number",
          placeholder: "Enter number of days",
        },

        // Age Range
        {
          key: "ageRange",
          label: "Age Range",
          type: "range",
          min: 13,
          max: 100,
          defaultValue: [18, 65],
          marks: [
            { value: 18, label: "18" },
            { value: 30, label: "30" },
            { value: 50, label: "50" },
            { value: 70, label: "70" },
          ],
        },

        // Location Filters
        {
          key: "city",
          label: "City",
          type: "multiselect",
          options: cityList.map((city) => ({ value: city, label: city })),
        },
        {
          key: "state",
          label: "State",
          type: "multiselect",
          options: stateList.map((state) => ({ value: state, label: state })),
        },
        {
          key: "pincode",
          label: "Pincode",
          type: "number",
          placeholder: "Enter pincode",
        },

        // Order Based Filters
        {
          key: "noOrdersSince",
          label: "No Orders Since",
          type: "select",
          options: [
            { value: "30", label: "Last 30 Days" },
            { value: "90", label: "Last 90 Days" },
            { value: "120", label: "Last 120 Days" },
            { value: "180", label: "Last 180 Days" },
          ],
        },

        // Category Filters
        {
          key: "orderCategory",
          label: "Ordered Category",
          type: "multiselect",
          options: categoryList.map((cat) => ({
            value: cat.id,
            label: cat.title,
          })),
        },
      ];
    } else {
      // Expert filters
      return [

        // Activity Based
        {
          key: "lastActive",
          label: "Last Active",
          type: "select",
          options: [
            { value: "7", label: "Within 7 Days" },
            { value: "30", label: "Within 30 Days" },
            { value: "90", label: "Within 90 Days" },
          ],
        },

        // Age Range
        {
          key: "ageRange",
          label: "Age Range",
          type: "range",
          min: 13,
          max: 100,
          defaultValue: [18, 65],
          marks: [
            { value: 18, label: "18" },
            { value: 30, label: "30" },
            { value: 50, label: "50" },
            { value: 70, label: "70" },
          ],
        },

        // Gender
        {
          key: "gender",
          label: "Gender",
          type: "multiselect",
          options: [
            { value: "Male", label: "Male" },
            { value: "Female", label: "Female" },
            { value: "Prefer Not To Say", label: "Prefer Not To Say" },
          ],
        },

        // Location Filters
        {
          key: "city",
          label: "City",
          type: "multiselect",
          options: cityList.map((city) => ({ value: city, label: city })),
        },
        {
          key: "state",
          label: "State",
          type: "multiselect",
          options: stateList.map((state) => ({ value: state, label: state })),
        },
        {
          key: "pincode",
          label: "Pincode",
          type: "number",
          placeholder: "Enter pincode",
        },

        // Booking Based Filters
        {
          key: "bookingsReceivedInDays",
          label: "Bookings Received in Last X Days",
          type: "number",
          placeholder: "Enter number of days",
        },
        {
          key: "noBookingsSince",
          label: "No Bookings Since Days",
          type: "number",
          placeholder: "Days without bookings",
        },
      ];
    }
  };
  const renderValueField = (field, index) => {
    const filterableColumns = getFilterableColumns();
    const selectedColumn = filterableColumns.find(
      (col) => col.key === filterOption[index]?.fieldName
    );
    const currentOperator = filterOption[index]?.operator;

    switch (selectedColumn?.type) {
      case "range":
        return (
          <Box sx={{ width: "100%", px: 2, py: 1 }}>
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.7rem",
                color: "text.secondary",
                mb: 1,
                display: "block",
              }}
            >
              {selectedColumn.label}:{" "}
              {field.value
                ? `${field.value[0]} - ${field.value[1]} years`
                : `${selectedColumn.defaultValue[0]} - ${selectedColumn.defaultValue[1]} years`}
            </Typography>
            <Slider
              {...field}
              disabled
              value={field.value || selectedColumn.defaultValue}
              onChange={(event, newValue) => {
                field.onChange(newValue);
              }}
              valueLabelDisplay="auto"
              min={selectedColumn.min}
              max={selectedColumn.max}
              marks={selectedColumn.marks}
              sx={{
                "& .MuiSlider-thumb": {
                  height: 16,
                  width: 16,
                },
                "& .MuiSlider-valueLabel": {
                  fontSize: "0.7rem",
                },
                "& .MuiSlider-markLabel": {
                  fontSize: "0.6rem",
                },
              }}
            />
          </Box>
        );

      case "date":
        if (currentOperator === "between") {
          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
                <DesktopDatePicker
                  disabled
                  label="Start Date"
                  value={field.value ? dayjs(field.value) : null}
                  onChange={(newValue) => {
                    field.onChange(
                      newValue
                        ? dayjs(newValue).endOf("day").toISOString()
                        : null
                    );
                  }}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      variant: "standard",
                      InputProps: {
                        style: { height: "1.6rem", fontSize: "0.75rem" },
                      },
                      InputLabelProps: { style: { fontSize: "0.75em" } },
                    },
                  }}
                />
                <DesktopDatePicker
                  label="End Date"
                  disabled
                  value={
                    filterOption[index]?.endValue
                      ? dayjs(filterOption[index]?.endValue)
                      : null
                  }
                  onChange={(newValue) => {
                    setValue(
                      `filterOption.${index}.endValue`,
                      newValue
                        ? dayjs(newValue).endOf("day").toISOString()
                        : null
                    );
                  }}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      variant: "standard",
                      InputProps: {
                        style: { height: "1.6rem", fontSize: "0.75rem" },
                      },
                      InputLabelProps: { style: { fontSize: "0.75em" } },
                    },
                  }}
                />
              </Box>
            </LocalizationProvider>
          );
        }

        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              disabled
            //   label={selectedColumn.label}
              value={field.value ? dayjs(field.value) : null}
              onChange={(newValue) => {
                field.onChange(
                  newValue ? dayjs(newValue).endOf("day").toISOString() : null
                );
              }}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  variant: "standard",
                  InputProps: {
                    style: { height: "1.6rem", fontSize: "0.75rem" },
                  },
                  InputLabelProps: { style: { fontSize: "0.75em" } },
                },
              }}
            />
          </LocalizationProvider>
        );

      case "multiselect":
        return (
          <Autocomplete
            {...field}
            multiple
            disabled
            size="small"
            options={selectedColumn.options || []}
            getOptionLabel={(option) => option.label || option}
            value={field.value || []}
            onChange={(event, newValue) => {
              field.onChange(newValue);
            }}
            renderTags={(value, getTagProps) =>
                
              value.map((option, index) => {
                const { onDelete, ...chipProps } = getTagProps({ index });
                return(
                <Chip
                  variant="outlined"
                  label={option.label || option}
                  size="small"
                  {...chipProps}
                  sx={{ fontSize: "0.65rem", height: "20px" }}
                />
              )})
            }
            renderInput={(params) => (
              <TextField
                {...params}
                disabled
                variant="standard"
                // label={selectedColumn.label}
                InputProps={{
                  ...params.InputProps,
                  style: {
                    fontSize: "0.75rem",
                    minHeight: "1.6rem",
                  },
                }}
                InputLabelProps={{
                  style: {
                    fontSize: "0.75em",
                  },
                }}
              />
            )}
            sx={{ width: "100%" }}
          />
        );

      case "select":
        return (
          <FormControl
            variant="standard"
            sx={{ width: "100%" }}
            size="small"
            disabled
          >
            {/* <InputLabel
              id={`select-label-${index}`}
              sx={{ fontSize: ".75em", lineHeight: "2em" }}
            >
              {selectedColumn.label}
            </InputLabel> */}
            <Select
              {...field}
              disabled
              labelId={`select-label-${index}`}
              value={field.value || ""}
              onChange={(e) => {
                field.onChange(e);
              }}
              sx={{
                minHeight: "0px",
                height: "1.6rem",
                fontSize: "0.75rem",
                fontWeight: "600",
                textTransform: "capitalize",
              }}
            >
              {selectedColumn.options.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{ fontSize: "0.75rem" }}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case "number":
        return (
          <TextField
            {...field}
            type="number"
            size="small"
            disabled
            variant="standard"
            // label={selectedColumn.placeholder || "Value"}
            placeholder={selectedColumn.placeholder}
            InputProps={{
              inputProps: {
                style: {
                  height: "1.2rem",
                  fontSize: "0.75rem",
                },
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: "0.75em",
              },
            }}
          />
        );

      case "boolean":
        return (
          <FormControl variant="standard" sx={{ width: "100%" }} size="small">
            {/* <InputLabel
              id={`boolean-label-${index}`}
              sx={{ fontSize: ".75em", lineHeight: "2em" }}
            >
              {selectedColumn.label}
            </InputLabel> */}
            <Select
              {...field}
              disabled
              labelId={`boolean-label-${index}`}
              value={field.value || ""}
              onChange={(e) => {
                field.onChange(e);
              }}
              sx={{
                minHeight: "0px",
                height: "1.6rem",
                fontSize: "0.75rem",
                fontWeight: "600",
                textTransform: "capitalize",
              }}
            >
              <MenuItem value="true" sx={{ fontSize: ".75rem" }}>
                Yes
              </MenuItem>
              <MenuItem value="false" sx={{ fontSize: ".75rem" }}>
                No
              </MenuItem>
            </Select>
          </FormControl>
        );

      default:
        return (
          <TextField
            {...field}
            size="small"
            disabled
            variant="standard"
            // label="Value"
            InputProps={{
              inputProps: {
                style: {
                  height: "1.2rem",
                  fontSize: "0.75rem",
                },
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: "0.75em",
              },
            }}
          />
        );
    }
  };

  return (
    <>
      <Typography
       
        sx={{
          textTransform: "none",
          fontSize: "0.75rem",
          fontWeight: 600,
        }}
      >
        ({activeBadgeContent})
        {activeBadgeContent>0 && ':'}
        {activeBadgeContent>0 && <Box component={"span"} sx={{ color: "#1976d2",cursor: "pointer", }} onClick={handleClick}>
          View Filters
        </Box>}
      </Typography>
      <Popover
        open={openFilterForm}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            width: { xs: "100%", md: "70%", lg: "60%" },
            p: "0.5rem 1rem",
            maxHeight: "80vh",
            overflowY: "auto",
          },
        }}
      >
        <FormProvider {...filterFormMethod}>
          {/* <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 500,
                mb: 1
              }}
            >
              Filter Options:
            </Typography>
          </Box> */}

          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
              Basic Filters
            </Typography>

            {fields.map((field, index) => (
              <Grid container spacing={1} key={field.id} sx={{ mb: 1 }}>
                {index === 0 ? (
                  <>
                    {fields.length > 1 && <Grid item xs={2} />}
                    <Grid item xs={3}>
                      <TextField
                        size="small"
                        fullWidth
                        disabled
                        inputProps={{
                          style: { fontSize: ".75rem" },
                        }}
                        value={filterOption[index].fieldName}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        size="small"
                        fullWidth
                        disabled
                        inputProps={{
                          style: { fontSize: ".75rem" },
                        }}
                        value={filterOption[index].operator}
                      />
                    </Grid>
                    <Grid item xs={fields.length === 1 ? 6 : 5}>
                      <Controller
                        name={`filterOption.${index}.value`}
                        control={control}
                        render={({ field: valueField }) =>
                          renderValueField(valueField, index)
                        }
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={2}>
                      <Controller
                        name={`filterOption.${index}.andOr`}
                        control={control}
                        defaultValue="and"
                        render={({ field: logicField }) => (
                          <TextField
                            size="small"
                            disabled
                            inputProps={{
                              style: { fontSize: ".75rem" },
                            }}
                            {...logicField}
                            value={logicField.value || "and"}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        size="small"
                        fullWidth
                        disabled
                        inputProps={{
                          style: { fontSize: ".75rem" },
                        }}
                        value={filterOption[index].fieldName}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        size="small"
                        fullWidth
                        disabled
                        inputProps={{
                          style: { fontSize: ".75rem" },
                        }}
                        value={filterOption[index].operator}
                      />
                    </Grid>
                    <Grid item xs={4.5}>
                      <Controller
                        name={`filterOption.${index}.value`}
                        control={control}
                        render={({ field: valueField }) =>
                          renderValueField(valueField, index)
                        }
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            ))}
            {/* Enhanced Location Filters Section */}
            {enableLocationFilters && (
              <>
                <Divider sx={{ my: 2 }} />
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <LocationOn fontSize="small" />
                  {audienceType == "customer"
                    ? "Location Filters"
                    : "Service Area Filters"}
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Controller
                      name="locationFilters.locationFilter"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <FormLabel
                            sx={{ fontSize: "0.85rem", fontWeight: 600, mb: 1 }}
                          >
                            Filter Type
                          </FormLabel>
                          <RadioGroup
                            {...field}
                            value={field.value || "radius"}
                            disabed
                          >
                            <FormControlLabel
                              value="radius"
                              disabled
                              control={<Radio size="small" />}
                              label={
                                <Typography sx={{ fontSize: "0.75rem" }}>
                                  Within Radius
                                </Typography>
                              }
                            />
                            {enableGeoFilters && (
                              <FormControlLabel
                                value="polygon"
                                disabled
                                control={<Radio size="small" />}
                                label={
                                  <Typography sx={{ fontSize: "0.75rem" }}>
                                    Geo Polygon
                                  </Typography>
                                }
                              />
                            )}
                          </RadioGroup>
                        </FormControl>
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={8}>
                    {locationFilters?.locationFilter === "radius" && (
                      <Box>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Controller
                              name="locationFilters.centerCoordinates.lat"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  disabled
                                  fullWidth
                                  size="small"
                                  label="Center Latitude"
                                  type="number"
                                  variant="standard"
                                  InputProps={{
                                    style: { fontSize: "0.75rem" },
                                    inputProps: {
                                      step: "any",
                                      min: -90,
                                      max: 90,
                                    },
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: "0.75em" },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Controller
                              name="locationFilters.centerCoordinates.lng"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  disabled
                                  fullWidth
                                  size="small"
                                  label="Center Longitude"
                                  type="number"
                                  variant="standard"
                                  InputProps={{
                                    style: { fontSize: "0.75rem" },
                                    inputProps: {
                                      step: "any",
                                      min: -180,
                                      max: 180,
                                    },
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: "0.75em" },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Controller
                              name="locationFilters.radius"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  disabled
                                  fullWidth
                                  size="small"
                                  label="Radius (km)"
                                  type="number"
                                  variant="standard"
                                  InputProps={{
                                    style: { fontSize: "0.75rem" },
                                    inputProps: { min: 0.1, step: 0.1 },
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: "0.75em" },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </>
            )}
          </Box>
        </FormProvider>
      </Popover>
    </>
  );
};

export default AllAppliedFIlters;
